import { GenericFormItem } from 'components/GenericForm/interfaces';
import i18n from 'i18n';

export const screenFields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: i18n.t('EMAIL_KEY'),
    stateKey: 'email',
    validateOnChange: true,
  },
  {
    gridXs: 12,
    label: i18n.t('PASSWORD_KEY'),
    stateKey: 'password',
    isPassword: true,
    validateOnChange: true,
  },
];
